import {HTMLAttributes} from 'react';

import styled, {css, CSSProperties} from 'styled-components';

import {BodyTypes, TextThemes} from 'components/design-guide';
import {generateTheme} from 'components/design-guide/utils';
import {Spacing, FontSize, FontFamily, FontWeight} from 'styles/Base';
import {Colors} from 'styles/Colors';
import {generateMargins, generatePadding, MarginProps, PaddingProps} from 'utils/components';

type TextProps = HTMLAttributes<HTMLElement> &
  MarginProps &
  PaddingProps & {
    type: BodyTypes;
    color?: Colors;
    fontWeight?: FontWeight;
    textTheme?: TextThemes;
    optionalCSS?: CSSProperties;
  };

const BodyStyles = css<TextProps>`
  color: ${({textTheme}: TextProps) => generateTheme(textTheme)};
  font-size: ${FontSize.ONE};
  line-height: ${Spacing.ONE_5};
  font-weight: ${({fontWeight}) => fontWeight ?? FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${(props) => generateMargins(props)};
  ${(props) => generatePadding(props)};
`;

export const SmallBodyStyles = css<TextProps>`
  color: ${({textTheme}) => generateTheme(textTheme)};
  font-size: ${FontSize.ZERO_875};
  line-height: ${Spacing.ONE_3125};
  font-weight: ${({fontWeight}) => fontWeight ?? FontWeight.REGULAR};
  font-family: ${FontFamily.DEFAULT};
  ${(props) => generateMargins(props)};
  ${(props) => generatePadding(props)};
`;

const BodySpan = styled.span<TextProps>`
  ${BodyStyles}
`;

const BodyP = styled.p<TextProps>`
  ${BodyStyles}
`;
const SmallBodySpan = styled.span<TextProps>`
  ${SmallBodyStyles}
`;

const SmallBodyP = styled.p<TextProps>`
  ${SmallBodyStyles}
`;

export const BodyText = (textProps: TextProps) => {
  const {type} = textProps;
  switch (type) {
    case BodyTypes.BODYP:
      return <BodyP {...textProps} style={textProps.optionalCSS} />;
    case BodyTypes.BODYSPAN:
      return <BodySpan {...textProps} style={textProps.optionalCSS} />;
    case BodyTypes.SMALLBODYP:
      return <SmallBodyP {...textProps} style={textProps.optionalCSS} />;
    case BodyTypes.SMALLBODYSPAN:
      return <SmallBodySpan {...textProps} style={textProps.optionalCSS} />;
    default:
      return <BodyP {...textProps} />;
  }
};
